/**
 * @desc 查询包含文章的目录树
 */
import {
  HelpCatalogueEntity,
  HelpCatalogueTreeWithDocQuery
} from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryHelpCatalogueTreeWithDocParameter =
  HelpCatalogueTreeWithDocQuery

const method = 'GET'
const url = '/content/mall/help/catalogue/tree/doc'

export const queryHelpCatalogueTreeWithDocApi = (
  params?: QueryHelpCatalogueTreeWithDocParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<HelpCatalogueEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryHelpCatalogueTreeWithDocApi.method = method
queryHelpCatalogueTreeWithDocApi.url = url
